import React, { Component, PropTypes } from 'react';
import CSSModules from 'react-css-modules';
import FullWidthRegion from './FullWidthRegion';
import ThumbnailList from './ThumbnailList';
import Separator from './Separator';
import styles from './Everything.css';
import * as library from '../lib/library';

const typeToGroupMap = {
  photography: 'Photography',
  sculpture: 'Sculpture',
  interactive: 'Interactive',
  painting: 'Painting & Drawing',
  installation: 'Installation',
};

function mapWorkToPaths(work) {
  return {
    imageInfo: work.images[0],
    url: `/works/${work.id}`,
  };
}

class Everything extends Component {
  static propTypes = {
    styles: PropTypes.objectOf(PropTypes.string),
  };

  constructor(...args) {
    super(...args);

    this.handleGroupByTypeClick = this.handleGroupByTypeClick.bind(this);
    this.handleGroupBySeriesClick = this.handleGroupBySeriesClick.bind(this);
    this.handleGroupByYearClick = this.handleGroupByYearClick.bind(this);
  }

  state = {
    groupBy: localStorage.getItem('groupBy') || 'series',
  };

  setGroupBy(groupBy) {
    localStorage.setItem('groupBy', groupBy);
    this.setState({ groupBy });
  }

  getImagesSets() {
    let groups = [];

    if (this.state.groupBy === 'type') {
      groups = [
        'photography',
        'sculpture',
        'interactive',
        'painting',
        'installation',
      ].map(type => ({
        title: typeToGroupMap[type],
        works: library.getWorksByType(type).map(mapWorkToPaths),
      }));
    } else if (this.state.groupBy === 'series') {
      groups = library.getAllSeries().map(series => ({
        title: series.title,
        works: series.works.map(id => library.getWorkById(id)).map(mapWorkToPaths),
      }));
    } else if (this.state.groupBy === 'year') {
      const works = library.getAllWorks();
      const years = {};

      works.forEach((work) => {
        if (!years[work.year]) {
          years[work.year] = [];
        }

        years[work.year].push(work);
      });

      groups = Object.keys(years).sort().reverse().map(year => ({
        title: year.toString(),
        works: years[year].map(mapWorkToPaths),
      }));
    } else {
      throw new Error();
    }

    return groups;
  }

  handleGroupByTypeClick(event) {
    this.setGroupBy('type');
  }

  handleGroupBySeriesClick(event) {
    this.setGroupBy('series');
  }

  handleGroupByYearClick(event) {
    this.setGroupBy('year');
  }

  render() {
    const imageSets = this.getImagesSets();
    const typeButtonStyleName = (this.state.groupBy === 'type') ? 'on' : '';
    const seriesButtonStyleName = (this.state.groupBy === 'series') ? 'on' : '';
    const yearButtonStyleName = (this.state.groupBy === 'year') ? 'on' : '';

    return (
      <div styleName="wrapper">
        <FullWidthRegion>
          <h2 styleName="title">Everything</h2>

          <div styleName="group-by">
            Group by:
            <button type="button" onClick={this.handleGroupBySeriesClick} styleName={seriesButtonStyleName}>Series</button>
            <button type="button" onClick={this.handleGroupByTypeClick} styleName={typeButtonStyleName}>Medium</button>
            <button type="button" onClick={this.handleGroupByYearClick} styleName={yearButtonStyleName}>Year</button>
          </div>

          <Separator
            theme={{
              'border-color-class': this.props.styles['group-by-separator-color'],
            }}
          />

          {
            imageSets.map((imageSet, index) => (
              <div styleName={index === 0 ? 'first' : ''} key={imageSet.title}>
                <h2 styleName="section-title">{imageSet.title}</h2>
                <ThumbnailList images={imageSet.works} hideIfListofOne={false} />
              </div>
            ))
          }
        </FullWidthRegion>
      </div>
    );
  }
}

export default CSSModules(Everything, styles, { errorWhenNotFound: false });



// WEBPACK FOOTER //
// ./application/js/components/Everything.js